const actions = {
    open: async ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            const option = {
                resolve,
                reject,
                ...payload,
            }
            commit('setModal', option)
        })
    },
    resolve({commit, state}) {
        state.resolve(true)
        commit('resetModalState')
    },
    reject({commit, state}) {
        state.reject(false)
        commit('resetModalState')
    },
};

export default actions;